export default __webpack_public_path__ + "static/image-with-text-tile.png";